module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_04_6DD79_1SE_GJ0.b64d34d1.png";